import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import DetailRow from 'src/components/DetailRow';
import useStyles from '../../styles';

const FideicomisoDetail = ({ contract }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader
        className={classes.header}
        title={
          <Typography className={classes.tableCell} component="h4" variant="h4">
            {t('CONTRACT_VIEW.FIDEICOMISO')}
          </Typography>
        }
      />
      <Divider className={classes.tableCell} />
      <CardContent style={{ padding: 0, marginBottom: '16px' }}>
        <Table>
          <TableBody>
            <DetailRow
              name={t('CONTRACT_VIEW.FIDEICOMISO')}
              value={contract.fideicomisoLabel ?? '-'}
            />
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

FideicomisoDetail.propTypes = {
  contract: PropTypes.object.isRequired
};

export default FideicomisoDetail;
